import { __awaiter, __generator } from "tslib";
import { InAppEvents, JourneysEvents, newEvent, allEvents, gistToCIO, ContentType } from './events';
import Gist from 'customerio-gist-web';
export { InAppEvents };
export function InAppPlugin(settings) {
    var _this = this;
    var _analytics;
    var _gistLoaded = false;
    var _pluginLoaded = false;
    var _eventTarget = new EventTarget();
    function attachListeners() {
        if (!_gistLoaded || _pluginLoaded)
            return;
        _analytics.on('reset', reset);
        if (settings.events) {
            allEvents.forEach(function (event) {
                _eventTarget.addEventListener(event, settings === null || settings === void 0 ? void 0 : settings.events);
            });
            ['messageDismissed', 'messageError'].forEach(function (event) {
                Gist.events.on(event, function (message) {
                    var _a, _b;
                    _eventTarget.dispatchEvent(newEvent(gistToCIO(event), {
                        messageId: message.messageId,
                        deliveryId: (_b = (_a = message.properties) === null || _a === void 0 ? void 0 : _a.gist) === null || _b === void 0 ? void 0 : _b.campaignId,
                    }));
                });
            });
        }
        Gist.events.on('messageShown', function (message) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var deliveryId = (_b = (_a = message === null || message === void 0 ? void 0 : message.properties) === null || _a === void 0 ? void 0 : _a.gist) === null || _b === void 0 ? void 0 : _b.campaignId;
            if (settings.events) {
                _eventTarget.dispatchEvent(newEvent(InAppEvents.MessageOpened, {
                    messageId: message === null || message === void 0 ? void 0 : message.messageId,
                    deliveryId: deliveryId,
                    message: {
                        dismiss: function () {
                            Gist.dismissMessage(message === null || message === void 0 ? void 0 : message.instanceId);
                        }
                    }
                }));
            }
            if (typeof deliveryId != 'undefined' && deliveryId != '') {
                _analytics.track(JourneysEvents.Metric, {
                    'deliveryId': deliveryId,
                    'metric': JourneysEvents.Opened,
                });
                return;
            }
            var broadcastId = (_e = (_d = (_c = message === null || message === void 0 ? void 0 : message.properties) === null || _c === void 0 ? void 0 : _c.gist) === null || _d === void 0 ? void 0 : _d.broadcast) === null || _e === void 0 ? void 0 : _e.broadcastIdInt;
            if (broadcastId) {
                var templateId = (_h = (_g = (_f = message === null || message === void 0 ? void 0 : message.properties) === null || _f === void 0 ? void 0 : _f.gist) === null || _g === void 0 ? void 0 : _g.broadcast) === null || _h === void 0 ? void 0 : _h.templateId;
                _analytics.track(JourneysEvents.Content, {
                    'actionType': JourneysEvents.ViewedContent,
                    'contentId': broadcastId,
                    'templateId': templateId,
                    'contentType': ContentType,
                });
            }
        });
        Gist.events.on('messageAction', function (params) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var deliveryId = (_c = (_b = (_a = params === null || params === void 0 ? void 0 : params.message) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.gist) === null || _c === void 0 ? void 0 : _c.campaignId;
            if (settings.events) {
                _eventTarget.dispatchEvent(newEvent(InAppEvents.MessageAction, {
                    messageId: params.message.messageId,
                    deliveryId: deliveryId,
                    action: params.action,
                    name: params.name,
                    actionName: params.name,
                    actionValue: params.action,
                    message: {
                        dismiss: function () {
                            Gist.dismissMessage(params.message.instanceId);
                        }
                    }
                }));
            }
            if (params.action == 'gist://close') {
                return;
            }
            if (typeof deliveryId != 'undefined' && deliveryId != '') {
                _analytics.track(JourneysEvents.Metric, {
                    'deliveryId': deliveryId,
                    'metric': JourneysEvents.Clicked,
                    'actionName': params.name,
                    'actionValue': params.action,
                });
                return;
            }
            var broadcastId = (_g = (_f = (_e = (_d = params === null || params === void 0 ? void 0 : params.message) === null || _d === void 0 ? void 0 : _d.properties) === null || _e === void 0 ? void 0 : _e.gist) === null || _f === void 0 ? void 0 : _f.broadcast) === null || _g === void 0 ? void 0 : _g.broadcastIdInt;
            if (broadcastId) {
                var templateId = (_l = (_k = (_j = (_h = params === null || params === void 0 ? void 0 : params.message) === null || _h === void 0 ? void 0 : _h.properties) === null || _j === void 0 ? void 0 : _j.gist) === null || _k === void 0 ? void 0 : _k.broadcast) === null || _l === void 0 ? void 0 : _l.templateId;
                _analytics.track(JourneysEvents.Content, {
                    'actionType': JourneysEvents.ClickedContent,
                    'contentId': broadcastId,
                    'templateId': templateId,
                    'contentType': ContentType,
                    'actionName': params.name,
                    'actionValue': params.action,
                });
            }
        });
        Gist.events.on('eventDispatched', function (gistEvent) {
            var _a, _b, _c;
            if (gistEvent.name == 'analytics:track') {
                var trackEventName = (_a = gistEvent.payload) === null || _a === void 0 ? void 0 : _a.event;
                if (typeof trackEventName === 'undefined' || trackEventName == '') {
                    return;
                }
                _analytics.track(trackEventName, (_b = gistEvent.payload) === null || _b === void 0 ? void 0 : _b.properties, (_c = gistEvent.payload) === null || _c === void 0 ? void 0 : _c.options);
            }
        });
    }
    function page(ctx) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var page;
            return __generator(this, function (_f) {
                if (!_pluginLoaded)
                    return [2 /*return*/, ctx];
                page = (_c = (_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : (_e = (_d = ctx.event) === null || _d === void 0 ? void 0 : _d.properties) === null || _e === void 0 ? void 0 : _e.url;
                if (typeof page === 'string' && page.length > 0) {
                    Gist.setCurrentRoute(page);
                }
                return [2 /*return*/, ctx];
            });
        });
    }
    function reset(ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Gist.clearUserToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, ctx];
                }
            });
        });
    }
    function syncUserToken(ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!_gistLoaded)
                            return [2 /*return*/, ctx];
                        user = _analytics.user().id();
                        if (!(typeof user === 'string' && user.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Gist.setUserToken(user)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, Gist.clearUserToken()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, ctx];
                }
            });
        });
    }
    var customerio = {
        name: 'Customer.io In-App Plugin',
        type: 'before',
        version: '0.0.1',
        isLoaded: function () { return _pluginLoaded; },
        load: function (ctx, instance) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _analytics = instance;
                        if (settings.siteId == null || settings.siteId == "") {
                            _error("siteId is required. Can't initialize.");
                            return [2 /*return*/, ctx];
                        }
                        return [4 /*yield*/, Gist.setup({
                                siteId: settings.siteId,
                                env: settings._env ? settings._env : "prod",
                                logging: settings._logging,
                                useAnonymousSession: settings.anonymousInApp,
                            })];
                    case 1:
                        _a.sent();
                        _gistLoaded = true;
                        return [4 /*yield*/, syncUserToken(ctx)];
                    case 2:
                        _a.sent();
                        attachListeners();
                        _pluginLoaded = true;
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        }); },
        identify: syncUserToken,
        page: page,
        unload: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (settings.events) {
                    allEvents.forEach(function (event) {
                        _eventTarget.removeEventListener(event, settings === null || settings === void 0 ? void 0 : settings.events);
                    });
                }
                return [2 /*return*/];
            });
        }); },
    };
    return customerio;
}
function _error(msg) {
    console.error("[Customer.io In-App Plugin] ".concat(msg));
}
//# sourceMappingURL=index.js.map